import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { GlassCard } from '@/components/ui/glass-card'

const cards = [
  {
    title: 'Five questions to ask any operator',
    description:
      "How to vet anyone you're considering investing with — including us. Each question with what good looks like and how Fairmeadow answers.",
    href: '/operator-questions',
    cta: 'Read the questions',
  },
  {
    title: 'Are we a fit for each other?',
    description:
      'Eight-question assessment covering capital range, time horizon, liquidity, and operator alignment. Submit to hear from Garrett within 1 – 2 business days.',
    href: '/fit',
    cta: 'Take the assessment',
  },
  {
    title: 'See the Track Record',
    description:
      'Every closed deal with full financials — purchase, financing, rent roll, occupancy. Public, not gated behind an investor portal.',
    href: '/track-record',
    cta: 'View the portfolio',
  },
]

export default function ForInvestorsPage() {
  return (
    <div className="bg-background text-foreground">
      <section className="border-border border-b">
        <div className="mx-auto max-w-5xl px-5 pt-14 pb-12 md:px-8 md:pt-20 md:pb-16">
          <h1 className="text-fluid-h1 text-navy mb-6 max-w-4xl">Evaluating Fairmeadow as an operator</h1>
          <p className="text-fluid-body-lg text-muted-foreground max-w-2xl">
            Three ways to check whether our hold period, liquidity, and reporting match what you need, before any
            capital changes hands.
          </p>
        </div>
      </section>

      <section className="px-5 py-16 md:px-8 md:py-24">
        <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-3">
          {cards.map((card) => {
            return (
              <GlassCard key={card.href} hover className="for-investors-card flex h-full flex-col">
                <h2 className="text-foreground mb-3 text-xl font-semibold">{card.title}</h2>
                <p className="text-muted-foreground mb-6 flex-1">{card.description}</p>
                <Link to={card.href}>
                  <Button variant="outline-gold" className="w-full">
                    {card.cta}
                  </Button>
                </Link>
              </GlassCard>
            )
          })}
        </div>
      </section>
    </div>
  )
}
